
import React, { forwardRef } from 'react';
//import  {withStyles,Grid}  from '@material-ui/core';
import  {Grid}  from '@material-ui/core';
import {Dropdown} from "react-bootstrap";
import SVG from "react-inlinesvg";
import DisplayLayout from '../../../app/pages/DisplayLayout'
import LayoutAvatar from '../../../app/pages/LayoutAvatar'
import { toAbsoluteUrl } from '../../_helpers';
import { FontAwesomeIcon } from '../../../../../../CommonComponents/AssetsHelper';

// const useStyles = withStyles(theme => ({
//     typography: {
//         padding: theme.spacing(2),
//     },
//     avatar: {
//         margin: 10,
//         borderRadius: 'unset',
//         width: 50,
//         height: 'auto',
//         cursor: 'pointer'
//     },
//     active: {
//         border: '1px solid #2b2b2b',
//         padding: '5px'
//     }
// }));



export const SceneDropDown = (props) => {
    //const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleClick(event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const activeSceneIMG = props.activeScene && props.activeScene.mixContentType ? props.activeScene.mixContentType : '001'
    const layoutUpdate = (id) => event => {
        props.layoutUpdate(id);
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }
    const selectedLayoutPanel = forwardRef((props, ref) => {
        return (
            <button
                ref={ref}
                onClick={e => {
                    e.preventDefault();
                    props.onClick(e);
                }}
                id="kt_subheader_quick_actions-layout"
                className="btn layout_dropdown_btn activeZone d-flex align-items-center justify-content-between rounded-0">

                <div className="layout_dropdown_view me-2">
                    <span>
                        <DisplayLayout active={activeSceneIMG} />
                    </span>
                </div>
                <FontAwesomeIcon type={'regular'} icon={'angle-down'} iconClass={''} />
            </button>
        );
    });

    return (
        <Dropdown className="dropdown-inline layout_dropdown" drop="down">
            <Dropdown.Toggle
                as={selectedLayoutPanel}
                id="dropdown-toggle-quick-actions-subheader-layout"
            />
            {/* styleClass={classes.avatar}  */}
            <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-sm dropdown-menu-right">
                <ul className="navi navi-hover d-flex align-items-center justify-content-center">
                    <Grid container justify="center" alignItems="center">
                        <LayoutAvatar layoutUpdate={layoutUpdate} sceneActive={activeSceneIMG} />
                    </Grid>
                </ul>
            </Dropdown.Menu>
        </Dropdown>

    );
}
